import './EnhancedEventViewSingleEvent.scss';
import { useTranslation } from 'react-i18next';
import EnhancedEventViewFlightSegment from '../EnhancedEventViewFlightSegment/EnhancedEventViewFlightSegment';
import EnhancedEventViewLayover from '../EnhancedEventViewLayover/EnhancedEventViewLayover';
import { getDateInWeekDayMonthDateFormat } from '../../../helpers/dateHelpers';
import { formatNumToTime } from '../../../helpers/timeHelpers';

function EnhancedEventViewSingleEvent({ pairingEvent, eventIndex, eventArray, actualView }) {

  const { t } = useTranslation();
  
  const getPairingDate = () => {
    if(!pairingEvent && !pairingEvent?.segments[0]?.departure.date) return '';
    return getDateInWeekDayMonthDateFormat(new Date(pairingEvent.segments[0].departure.date+' 00:00'));
  }

  const getPickUpCheckIn = () => {
    if(pairingEvent?.checkInBefore) return pairingEvent.checkInBefore;
    if(pairingEvent?.pickUpBefore) return pairingEvent.pickUpBefore;
    return '';
  }

  return (
    <div className="c-ev-single-event">
      <div className="c-header">
        <p className="header__date">{getPairingDate()}</p>
        <p className="header__check-in">{getPickUpCheckIn()}</p>
        <p>{(pairingEvent?.checkInBefore || pairingEvent?.pickUpBefore) && t('myBlockMonth.dutyDay' , {dutyDayValue: pairingEvent?.dutyDay?.value ? formatNumToTime(pairingEvent?.dutyDay?.value) : '00:00'})}</p>
      </div>

      {pairingEvent && pairingEvent.segments.map((segment, index, array) => {
        return (
          <div key={index}>
            <EnhancedEventViewFlightSegment actualView={actualView} pairingSegment={segment} />
            {segment?.hotelSegment && segment?.hotelSegment.length > 0 && segment?.hotelSegment[0]?.totalLayover?.value > 0 && (
              <EnhancedEventViewLayover pairingSegment={segment}/>
            )}
            {!(eventIndex === eventArray.length - 1) && (index === array.length - 1) && <div className="event-separator" />}        
          </div>
        );
      })}
    </div>

  );
}

export default EnhancedEventViewSingleEvent;
